import Lyric from './Lyric'
import LyricAST, { WordToken } from './LyricAST'

const markedKeyMap = {
  ti: 'trackName',
  ar: 'singerName',
  al: 'albumName',
  by: 'author',
}

const trcMetaReg = /\[(\w+):(.*)\]/ // 提取歌词前面的 [ti [ar 等元信息
const lineTimeReg = /\[(\d+),(\d+)\](.*)/ // 提取 1、行开始时间 2、行持续时间 3、行逐字文字以及时间
const wordTimeReg = /(?<=\()\d+,\d+(?=\))/g // 提取出每个字的开始时间和持续时间 time,time
const wordTextReg = /(?:(?<=\d\))|^).*?(?=\(\d+,\d+\))/g // 提取出一行中每个字

export default class Trc extends Lyric {
  constructor(type = 'lyricQrc', lyricText = '') {
    super(type, lyricText)
    this.nameExt = '_trc'
    this._template = `<?xml version="1.0" encoding="utf-8"?>
<QrcInfos>
<QrcHeadInfo SaveTime="__timestamp__" Version="100"/>
<LyricInfo LyricCount="1">
<Lyric_1 LyricType="1" LyricContent="[ti:__trackName__]
[ar:__singerName__]
[al:__albumName__]
[by:__author__]
[offset:0]
__content__"/>
</LyricInfo>
</QrcInfos>`
  }

  /**
   * @override
   */
  textToAST() {
    const { lyricText } = this

    // console.log(lyricText)
    const reg = /\?<=LyricContent="[\S\s]*(?="\/>\s*<\/LyricInfo>)/
    const matcher = lyricText.match(reg)
    // const lyric = doc.querySelector('Lyric_1')
    if (!matcher) {
      throw Error('歌词格式不正确，无法编辑')
    }
    const lyricContent = matcher[0]
    // console.log(lyricContent)
    let sentence = lyricContent.split(/\r|\n|\r\n/g)

    // 1、去掉每行前后的不可见字符
    // 2、剔除空行
    sentence = sentence.map(s => {
      return s.trim()
    }).filter(s => {
      return s !== ''
    })

    const sentencesLength = sentence.length

    const markedInfo = {} // 歌词 meta 信息
    const lineTimeList = [] // 二维数组，每行的开始时间和持续时间[[0, 2], [2, 3]]
    const lineTextList = [] // ['第一行', '第二行',...]
    const lineWordList = [] // 二维数组，[['第', '一', '行'], ['第','二','行'],..]
    const tokenObjList = [] // list<WordToken>

    for (const line of sentence) {
      const metaObj = line.match(trcMetaReg)

      // 提取 meta 信息
      if (metaObj) {
        // console.log(metaObj)
        const key = markedKeyMap[metaObj[1]]
        if (key) {
          markedInfo[key] = metaObj[2]
        }
        continue
      }

      const lineTimeMatch = line.match(lineTimeReg)
      // console.log(lineTimeMatch)

      // 设置每行的开始时间和持续时间 line_start, line_duration
      lineTimeList.push([lineTimeMatch[1], lineTimeMatch[2]])
      const lineText = lineTimeMatch[3]

      const wordTimeList = lineText.match(wordTimeReg) // 提取所有词时间
      const wordTextList = lineText.match(wordTextReg) // 提取所有词内容
      const wordTokenList = []
      // console.log(wordTimeList)
      // console.log(wordTextList)
      for (let index = 0; index < wordTimeList.length; index++) { // 组合每个词的内容和时间，生成词 token 对象
        const word = wordTextList[index]
        const [start, duration] = wordTimeList[index].split(',')
        const wordToken = new WordToken(word)
        wordToken.start = start
        wordToken.duration = duration
        wordTokenList.push(wordToken)
      }

      lineTextList.push(wordTextList.join(''))
      tokenObjList.push(wordTokenList)
      lineWordList.push(wordTextList)
    }

    // 生成歌词 AST，复制各个属性
    const lyricAST = new LyricAST('', markedInfo, { autoAST: false })
    lyricAST.lyricText = lyricContent
    lyricAST.ASTList = tokenObjList
    lyricAST.sentencesTextList = lineTextList
    lyricAST.sentencesWordsList = lineWordList
    lyricAST.sentencesTimeList = lineTimeList
    lyricAST.sentencesLength = sentencesLength

    this.lyricAST = lyricAST
    return lyricAST
  }
}
